import { zones } from "@/mocks/homeData";
import SectionHeading from "@/pages/home/components/SectionHeading";

const zoneTargets: Record<string, string> = {
  "zone-01": "#topics",
  "zone-02": "#topics",
  "zone-03": "#circles",
  "zone-04": "#tags",
  "zone-05": "#groups",
  "zone-06": "#topics",
};

export default function ZonesSection() {
  return (
    <section id="zones" className="w-full border-t border-background-200 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Zones · 分区导航"
          title="六类分区，按你的目的进入"
          desc="想追热点走热榜，想看清来龙去脉走时间线，想找同好走圈子与群组，想交叉筛选走标签，各取所需。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {zones.map((zone, index) => (
            <a
              key={zone.id}
              href={zoneTargets[zone.id] ?? "#topics"}
              className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${zone.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <div>
                <h4 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {zone.name}
                </h4>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{zone.desc}</p>
              </div>
              <span className="mt-auto flex items-center gap-1 text-xs font-medium text-foreground-500">
                {zone.count}
                <i className="ri-arrow-right-up-line text-primary-500"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}